const entity = {
  urls: {
    index: '/authors',
    link: document => `/author/${document.uid}`
  },
  labels: {
    singular: 'auteur',
    singularAlt: 'Auteur',
    plural: 'auteurs',
    pluralAlt: 'Auteurs'
  }
}

exports.entity = entity

exports.getHeadline = () => ({
  meta: entity.labels.singularAlt,
  link: {
    text: `alle ${entity.labels.plural}`,
    url: entity.urls.index
  }
})

exports.create = async (graphql, createPage, wrapper) => {
  createPage({
    path: entity.urls.index,
    component: require.resolve('./page.jsx')
  })

  const result = await wrapper(
    graphql(`
      {
        allPrismicAuthor {
          edges {
            node {
              uid
              data {
                name
              }
            }
          }
        }
      }
    `)
  )

  result.data.allPrismicAuthor.edges.forEach(edge => {
    createPage({
      path: entity.urls.link(edge.node),
      component: require.resolve('./template.jsx'),
      context: {
        uid: edge.node.uid
      }
    })
  })

  return result.data.allPrismicAuthor.edges
}
